import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { Button, PageHeader } from '@pushly/aqe/lib/components'
import { Tabs } from 'antd'
import { useEffect, useState } from 'react'
import PageAnalysisConfigDetailsTab from '@halo/portals/post-auth/page-analysis-configs/page-analysis-config_details.tab'
import PageAnalysisFieldConfigsTab from '@halo/portals/post-auth/page-analysis-configs/page-analysis-config_field-configs.tab'
import './style/edit-page-analysis-config.page.scss'
import { PageAnalysisConfigsService } from '@halo/services/page-analysis-configs.service'
import { Container } from 'typescript-ioc'
import TestPageAnalysisDrawer from '@halo/components/test-page-analysis-drawer/test-page-analysis-drawer'
import { PageCategoriesService } from '@pushly/aqe/lib/services'
import { IHydratedPageAnalysisConfig } from '@halo/interfaces/hydrated-page-analysis-config'
import { noop } from '@pushly/aqe/lib/utils/noop'
import { IPageCategory } from '@pushly/aqe/lib/interfaces'

function EditPageAnalysisConfigPage(props: any) {
    const pageCategoriesService: PageCategoriesService = Container.get(PageCategoriesService)
    const pageAnalysisConfigsService: PageAnalysisConfigsService = Container.get(PageAnalysisConfigsService)
    const pageAnalysisConfigId = props.match.params.pageAnalysisConfigId

    const activeTab = location.hash.replace(/^#/, '').toLowerCase() || 'details'
    const [currentTabKey, setCurrentTabKey] = useState<string>(activeTab)
    const [hydratedPageAnalysisConfig, setHydratedPageAnalysisConfig] = useState<IHydratedPageAnalysisConfig>()
    const [pageCategories, setPageCategories] = useState<IPageCategory[]>()
    const [isTesting, setIsTesting] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        const hydrate = async () => {
            setIsLoading(true)

            const res = await Promise.all([fetchPageCategories(), fetchHydratedPageAnalysisConfig()])

            const [pc, hpac] = res

            setPageCategories(pc)
            setHydratedPageAnalysisConfig(hpac)

            setIsLoading(false)
        }

        hydrate()
    }, [pageAnalysisConfigId])

    async function fetchPageCategories() {
        return (await pageCategoriesService.fetchAll({ query: { domainIds: 'all' } })).data
    }

    async function fetchHydratedPageAnalysisConfig(): Promise<IHydratedPageAnalysisConfig> {
        const res = await pageAnalysisConfigsService.fetchById(pageAnalysisConfigId, {
            query: {
                hydrated: true,
            },
        })
        return res.data as IHydratedPageAnalysisConfig
    }

    function render() {
        return (
            <>
                <div className={classnames('page', 'single-domain')}>
                    <div className={classnames('page-wrapper')}>
                        <PageHeader
                            title={
                                hydratedPageAnalysisConfig?.name
                                    ? `Page Analysis Config: ${hydratedPageAnalysisConfig?.name}`
                                    : 'Page Analysis Config'
                            }
                            action={
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setIsTesting(true)
                                    }}
                                    icon="caret-right"
                                >
                                    Test Page Analysis Config
                                </Button>
                            }
                            onTitleSet={noop}
                        />

                        <Tabs
                            size="small"
                            animated={{ inkBar: false, tabPane: false }}
                            tabPosition="top"
                            activeKey={currentTabKey}
                            onChange={(key) => {
                                location.hash = key
                                setCurrentTabKey(key)
                            }}
                        >
                            <Tabs.TabPane disabled={isLoading} key="details" tab="Details">
                                <PageAnalysisConfigDetailsTab
                                    hydratedPageAnalysisConfig={hydratedPageAnalysisConfig}
                                    onUpdate={async (hpac) => {
                                        setHydratedPageAnalysisConfig(hpac)
                                    }}
                                />
                            </Tabs.TabPane>

                            <Tabs.TabPane disabled={isLoading} key="field-configs" tab="Field Configs">
                                <PageAnalysisFieldConfigsTab
                                    hydratedPageAnalysisConfig={hydratedPageAnalysisConfig}
                                    onUpdate={async (hpac) => {
                                        setHydratedPageAnalysisConfig(hpac)
                                    }}
                                />
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>

                <TestPageAnalysisDrawer
                    title="Test Page Analysis"
                    hydratedPageAnalysis={isTesting && hydratedPageAnalysisConfig}
                    onClose={() => setIsTesting(false)}
                    pageCategories={pageCategories}
                />
            </>
        )
    }

    return render()
}

export default EditPageAnalysisConfigPage
